import { CancelContractMutation } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

// 解約を行う
export const cancelContractMutationHandler =
  graphql.mutation<CancelContractMutation>(
    "cancelContract",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          cancelContract: {
            result: true,
          },
        },
      });
    }
  );
